enum VotingSystem {
	one = '0,1,2,3,5,8,13,20,40,100,?,☕️',
	two = '0,½,1,2,3,5,8,13,20,40,100,?,☕️',
	three = 'XS,S,M,L,XL,XXL,2XL,3XL,?,☕️',
}

export {
	VotingSystem
}
